import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Kigali Rwanda Car Hire | Car Rental Kigali | Self Drive & 4x4',
      description: 'Rent a car in Kigali with Kigali Rwanda Car Hire. Affordable car rental in Rwanda, self-drive, 4x4, and driver options. Book now: (+250) 782 336 854',
      keywords: 'car rental Kigali, Rwanda car hire, Kigali car rental, rent a car Rwanda, Kigali car rental self drive, 4x4 car hire Rwanda, cheap car rental Kigali'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: 'About Kigali Rwanda Car Hire | Rwanda Car Rental Services',
      description: 'Learn about Kigali Rwanda Car Hire, your trusted partner for car rental in Kigali. Offering self-drive, 4x4, and driver services across Rwanda.',
      keywords: 'Kigali car rental, Rwanda car hire, about car rental Kigali, 4x4 rental Rwanda, rent a car in Kigali'
    }
  },
  {
    path: '/car-listing',
    name: 'CarListing',
    component: () => import('../views/CarListing.vue'),
    meta: {
      title: 'Car Rental Kigali | 4x4 & Self Drive Cars in Rwanda',
      description: 'Explore our fleet of rental cars in Kigali, including 4x4, self-drive, and safari vehicles. Book your car with Kigali Rwanda Car Hire today!',
      keywords: 'car rental Kigali, 4x4 car hire Rwanda, Kigali car rental self drive, Rwanda car rental, safari car rental Rwanda'
    }
  },
  {
    path: '/clients-review',
    name: 'ClientsReview',
    component: () => import('../views/ClientsReview.vue'),
    meta: {
      title: 'Client Reviews | Kigali Rwanda Car Hire Testimonials',
      description: 'Read customer reviews for Kigali Rwanda Car Hire. Discover why we’re the top choice for car rental in Kigali and Rwanda.',
      keywords: 'Kigali car rental reviews, Rwanda car hire testimonials, car rental Kigali feedback, Kigali Rwanda car hire reviews'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactView.vue'),
    meta: {
      title: 'Contact Kigali Rwanda Car Hire | Book Car Rental Kigali',
      description: 'Contact Kigali Rwanda Car Hire for car rental in Kigali. Reach us at (+250) 782 336 854 or info@kigalirwandacarhire.com for bookings.',
      keywords: 'contact car rental Kigali, Rwanda car hire contact, Kigali car rental, rent a car Kigali, Kigali airport car hire'
    }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('../views/BlogView.vue'),
    meta: {
      title: 'Rwanda Car Rental Blog | Travel Tips & Kigali Car Hire Guides',
      description: 'Expert Rwanda travel tips, car rental guides, safari advice, and gorilla trekking information from Kigali Rwanda Car Hire.',
      keywords: 'Rwanda travel blog, car rental Kigali guide, gorilla trekking Rwanda, Rwanda safari tips, Kigali car hire blog'
    }
  },
  {
    path: '/blog/:slug',
    name: 'BlogPost',
    component: () => import('../views/BlogPostView.vue')
  },
  {
    path: '/destinations',
    name: 'Destinations',
    component: () => import('../views/DestinationsView.vue'),
    meta: {
      title: 'Rwanda Destinations | Top Places to Visit & Car Hire Guide | Kigali Rwanda Car Hire',
      description: 'Discover Rwanda\'s top destinations: Volcanoes National Park, Akagera, Nyungwe Forest, Lake Kivu & Kigali. Hire a car from Kigali for any destination.',
      keywords: 'Rwanda destinations car hire, places to visit Rwanda, gorilla trekking transport, Akagera safari car rental, Lake Kivu car hire, Nyungwe Forest transport Rwanda'
    }
  },
  {
    path: '/destinations/:slug',
    name: 'Destination',
    component: () => import('../views/DestinationView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  document.title = to.meta.title || 'Kigali Rwanda Car Hire'
  // Dynamically update meta tags
  const metaDescription = document.querySelector('meta[name="description"]')
  const metaKeywords = document.querySelector('meta[name="keywords"]')
  if (metaDescription) metaDescription.setAttribute('content', to.meta.description || '')
  if (metaKeywords) metaKeywords.setAttribute('content', to.meta.keywords || '')
})

export default router
